import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import FlowReassignModal from './FlowReassignModal';

const FlowReassignModalBridge = react2angular(FlowReassignModal, [
  'reassignType',
  'currentStep',
  'currentTask',
  'flowId',
  'stepId',
  'flowIdentifier',
  'onClose',
  'onSuccess'
]);

export default FlowReassignModalBridge;
